import { render } from "./Slider.vue?vue&type=template&id=1d7c1266&scoped=true&ts=true"
import script from "./Slider.ts?vue&type=script&lang=ts&external"
export * from "./Slider.ts?vue&type=script&lang=ts&external"

import "./Slider.vue?vue&type=style&index=0&id=1d7c1266&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7c1266"]])

export default __exports__